<template>
    <div class="nouvelles">
        <header page-transition-group>
            <HeroGraphicText v-if="contentIsLoaded" />
        </header>

        <div class="page-content" page-transition-group>

            <section>
                <!-- <div class="container-xxl padding-container-top">
                    <div
                        class="row default-fliters-wrapper align-items-center justify-content-md-between px-lg-4"
                    >
                        <div
                            class="col-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-start"
                        >
                            <IconInis name="filter" />
                            <span class="d-inline-block text-uppercase bold ms-3">{{
                                $t('Filtres')
                            }}</span>
                        </div>
                        <div
                            class="col-12 col-md-auto d-flex align-items-center justify-content-center flex-column flex-md-row mt-3 mt-md-0"
                        >
                            <span class="text-weight-semibold text-small me-md-4 mb-2 mb-md-0">{{
                                $t('Sélectionner une année')
                            }}</span>
                            <div class="select-wrapper">
                                <select
                                    name="filter"
                                    id="filter"
                                    v-model="filter"
                                    @change="filterNews()"
                                >
                                    <option value="">{{ $t('Toutes les années') }}</option>
                                    <option :value="item" v-for="(item, i) in filters" :key="i">
                                        {{ item }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div> -->

                <div class="container-xxl pt-5">
                    <div class="row">
                        <div class="col-12">
                            <router-link
                                :to="{ name: 'blogue-fr' }"
                                class="link-arrow left bold text-uppercase text-red mb-0"
                                itemtype="https://www.schema.org/SiteNavigationElement"
                            >
                                {{ $t('Retour au blogue') }}
                            </router-link>
                        </div>
                    </div>
                </div>

                <div class="container-xxl padding-container-top">

                    <div class="row">
                        <div class="col-12">
                            <h3 v-if="contentIsLoaded" v-html="getActiveCat()"></h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="sep-hor-thick-black mt-3"></div>
                        </div>
                    </div>
                </div>

            </section>

            <section v-if="newsIsLoaded">
                <div class="container-xxl padding-container-bottom ">

                    <div class="row">
                        <NewsCard
                            v-for="(news, index) in news.data"
                            :key="'news-' + index"
                            :newsData="news"
                            :showColumn="true"
                        />
                    </div>

                    <div
                        v-if="
                            news.meta.pagination.current_page !== news.meta.pagination.total_pages
                        "
                        class="row justify-content-center padding-container-xs"
                    >
                        <div class="col-auto">
                            <button
                                v-on:click="fetchNews(news.meta.pagination.current_page + 1)"
                                class="button secondary"
                            >
                                {{ $t('Voir plus') }}
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
// import IconInis from '@/components/svgs/IconInis'
import { mapState, mapGetters, mapActions } from 'vuex'
import HeroGraphicText from '@/components/hero/HeroGraphicText.vue'
import axios from 'axios'

import NewsCard from '@/components/loopTemplate/NewsCard'

export default {
    name: 'BlogCategorie',
    components: {
        HeroGraphicText,
        // IconInis,
        NewsCard,
    },
    data() {
        return {
            news: { data: [] },
            newsIsLoaded: false,
            filterValues: null,
            filters: [],
            filter: '',
            // activeBlogType: this.globals.blogType.find(s => s.slug === this.$route.params.slug).title,
        }
    },
    watch: {
        pageIsLoaded: {
            async handler(pageIsLoaded) {
                if (pageIsLoaded) {
                    // Page loaded with Data
                    this.setBgTheme(this.content.heroGraphicText.heroBackgroundColor)
                    this.fetchNews()
                    // this.filterValues = this.globals.contact.BlogfilterValues

                    // for (
                    //     let index = parseInt(this.filterValues.from);
                    //     index >= parseInt(this.filterValues.to);
                    //     index--
                    // ) {
                    //     this.filters.push(index)
                    // }
                }
            },
            immediate: true,
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg', 'setBgTheme']),
        filterNews() {
            this.newsIsLoaded = false
            this.news = {
                data: [],
                meta: null,
            }
            this.fetchNews(1)
        },
        async fetchNews(currentPage = 1) {
            await axios
                .get(
                    `${
                        process.env.VUE_APP_SITE_BASE_URL + '/api'
                    }/blogType/${this.globals.blogType.find(s => s.slug === this.$route.params.slug).slug}.json?page=${currentPage}`
                )
                .then(res => {
                    this.news = {
                        data: [...this.news.data, ...res.data.data],
                        meta: res.data.meta,
                    }
                    this.newsIsLoaded = true
                })

                .catch(() => {})
        },
        getActiveCat(){
          return this.globals.blogType.find(s => s.slug === this.$route.params.slug).title
        },

    },
}
</script>

<style lang="scss"></style>
